import { Component } from "react"

/* Components */
import { InnerLayout, Pagination } from "../../components"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import {
    SearchIcon, CloseIcon, PlayersIcon, OperatorIcon, BetsIcon, ChipIcon,
    ArrowRightIcon, WarningIcon, RefundIcon, ArrowIcon, HandIcon,
} from "../../components/Icons"


/* HOW MANY PLAYERS EVERY PAGE HOLDS — THE SERVER OF EVERY GAME ANSWERS WITH TEN */
const SIZE = 10


/*
    Component RoundPlayers — THE PLAYERS OF ONE ROUND, THE SAME LIST IN EVERY GAME

    Every row carries what an operator asks about first: how many bets the player put in,
    what they add up to, and the wallet of the player before and after the round.
    The balances come from the central GameTransactions — the only place that records them.

    data        the players of the open page
    status      the state of the request
    page, count the pagination of the list
    number      the code the list is searched by
    onSearch    the search runs on submit and on a cleared field
    onNumber    the field changed
    onPage      another page was asked for
    onOpen      a row was clicked
    reload      the request runs again
*/
class RoundPlayers extends Component {

    /* THE FAILED AND THE HANGING TRANSACTIONS OF ONE PLAYER */
    getProblem = (item) => {

        /* Fields */
        const failed = parseInt(item.failed) > 0 ? parseInt(item.failed) : 0
        const pending = parseInt(item.pending) > 0 ? parseInt(item.pending) : 0

        /* Check Counters */
        if (failed === 0 && pending === 0) {
            return null
        }

        /* A Failure Outweighs A Hanging Request */
        return {
            tone: failed > 0 ? "failed" : "pending",
            count: failed + pending,
            hint: [
                failed > 0 ? `${t("gtx.failed")}: ${failed}` : "",
                pending > 0 ? `${t("gtx.pending")}: ${pending}` : "",
            ].filter((part) => part).join(" · "),
        }
    }

    /* Submit Action */
    submit = (event) => {

        /* Fields */
        const { onSearch } = this.props

        /* A Form Never Reloads The Page */
        if (event) {
            event.preventDefault()
        }

        onSearch()
    }

    /* Draw One Money Cell */
    _cell = (icon, title, value, item, tone) => (
        <div className="rnd--player-cell">

            <div className="rnd--player-cell-title">
                {icon}
                <span>{title}</span>
            </div>

            <div className={`rnd--player-cell-value ${tone ? tone : ""}`}>
                {`${utils.checkValue(value)}`.trim() === "" ? "—" : utils.convertor(value, item.symbol, item.isAfter)}
            </div>

        </div>
    )

    /* Draw The Wallet Of The Player Around The Round */
    _balance = (item) => {

        /* Fields */
        const before = `${utils.checkValue(item.balanceBefore)}`.trim()
        const after = `${utils.checkValue(item.balanceAfter)}`.trim()

        /* Nothing Was Recorded — the operator never answered the round */
        if (before === "" && after === "") {
            return (
                <div className="rnd--player-cell wide">

                    <div className="rnd--player-cell-title">
                        <ArrowRightIcon size={12} />
                        <span>{t("round.balance")}</span>
                    </div>

                    <div className="rnd--player-cell-value empty" title={t("round.balanceEmpty")}>—</div>

                </div>
            )
        }

        return (
            <div className="rnd--player-cell wide">

                <div className="rnd--player-cell-title">
                    <ArrowRightIcon size={12} />
                    <span>{t("round.balance")}</span>
                </div>

                <div className="rnd--player-balance">
                    <p>{before === "" ? "—" : utils.convertor(item.balanceBefore, item.symbol, item.isAfter)}</p>
                    <ArrowRightIcon size={12} />
                    <p className="after">{after === "" ? "—" : utils.convertor(item.balanceAfter, item.symbol, item.isAfter)}</p>
                </div>

            </div>
        )
    }

    /* Draw One Player */
    _row = (item, index) => {

        /* Fields */
        const { page, onOpen } = this.props

        /* Fields */
        const problem = this.getProblem(item)
        const position = ((page > 0 ? page : 1) - 1) * SIZE + index + 1
        const refunds = parseInt(item.refunds) > 0 ? parseInt(item.refunds) : 0

        return (
            <div onClick={() => onOpen(item)} className={`rnd--player ${problem ? `problem ${problem.tone}` : ""}`} key={`${item.id}`}>

                {/* Who The Player Is */}
                <div className="rnd--player-head">

                    <div className="rnd--player-index">{position}</div>

                    <div className="rnd--player-name">
                        <h4>{`${utils.checkValue(item.firstName)}`.trim() === "" ? item.player : item.firstName}</h4>
                        <p>{item.player}</p>
                    </div>

                    <div className="rnd--player-marks">

                        {/* The Box Of The Player — only the games that seat one player per box carry it */}
                        {Object.prototype.hasOwnProperty.call(item, "box") && item.box
                            ? <div className="rnd--player-mark"><HandIcon size={11} />BOX {item.box}</div>
                            : null
                        }

                        {/* The Boxes Of The Player — the games where one player may hold several boxes send them all, "1,2,3" */}
                        {`${utils.checkValue(item.boxes)}`.trim() !== ""
                            ? `${item.boxes}`.split(",").map((box) => <div className="rnd--player-mark" key={`box-${box}`}><HandIcon size={11} />BOX {box.trim()}</div>)
                            : null
                        }

                        {/* The Operator Of The Player */}
                        <div className="rnd--player-mark">
                            <OperatorIcon size={11} />
                            {`${utils.checkValue(item.operator)}`.trim() === "" ? "—" : item.operator}
                        </div>

                        {/* The Money That Went Back To The Player */}
                        {refunds > 0 &&
                            <div className="rnd--player-mark violet"><RefundIcon size={11} />{refunds}</div>
                        }

                        {/* The Money Of The Player Never Went Through */}
                        {problem &&
                            <div className={`rnd--player-mark ${problem.tone}`} title={problem.hint}>
                                <WarningIcon size={11} />
                                {problem.count}
                            </div>
                        }

                    </div>

                    <div className="rnd--player-arrow"><ArrowIcon size={13} /></div>

                </div>

                {/* What The Player Did In The Round */}
                <div className="rnd--player-cells">

                    <div className="rnd--player-cell">

                        <div className="rnd--player-cell-title">
                            <BetsIcon size={12} />
                            <span>{t("round.bets")}</span>
                        </div>

                        <div className="rnd--player-cell-value">{parseInt(item.bets) > 0 ? parseInt(item.bets) : 0}</div>

                    </div>

                    {this._cell(<ChipIcon size={12} />, t("round.betsTotal"), item.debit, item)}

                    {this._balance(item)}

                </div>

            </div>
        )
    }

    /* Draw The List Itself */
    _list = () => {

        /* Fields */
        const { status, data, page, count, onPage, reload } = this.props

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => reload()} />
        }

        /* Empty List */
        if (!data || !Array.isArray(data) || data.length === 0) {
            return <div className="rnd--players-empty">{t("layout.empty")}</div>
        }

        return (
            <>
                <div className="rnd--players-list">
                    {data.map((item, index) => this._row(item, index))}
                </div>

                <Pagination size={SIZE} page={page} total={count} onPageChange={(value) => onPage(value)} />
            </>
        )
    }

    render = () => {

        /* Fields */
        const { number, count, onNumber } = this.props

        return (
            <div className="rnd--players">

                <div className="rnd--players-head">

                    <div className="rnd--players-title">
                        <PlayersIcon size={14} />
                        {t("round.players")}
                        {parseInt(count) > 0 && <span className="rnd--players-count">{count}</span>}
                    </div>

                    <form onSubmit={this.submit} className="rnd--players-search">

                        <div className="rnd--field">

                            <SearchIcon size={14} />

                            <input value={number} placeholder={t("widget.searchByPlayerNumber")} onChange={(event) => onNumber(event.target.value)} />

                            {`${number}`.trim() !== "" &&
                                <div onClick={() => onNumber("")} className="rnd--field-clear"><CloseIcon size={10} /></div>
                            }

                        </div>

                        <button type="submit" className="rnd--players-submit"><SearchIcon size={14} /></button>

                    </form>

                </div>

                {/* Draw List */}
                {this._list()}

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(RoundPlayers)
